import { properties } from '../property'
import { describeTable } from './describeTable'

describeTable(properties, {
  description: `One building or dwelling (kohde) that work is done at, owned by exactly one customer. Every customer job hangs off it: visits.property_id → properties → customers, and subscriptions.property_id likewise. The postal address and coordinates are on addresses (address_id).
Prospect-import housing companies and agencies have NO properties row (their address is customers.address_id), so "customers with a property" is a good first filter for served customers. Legacy Nalas customers got one property per imported address. A customer can own several properties (e.g. a housing company with multiple buildings, or a household with a summer cottage).`,
  columns: {
    customerId: 'Owning customer account.',
    propertyType:
      'detached_house = omakotitalo, semi_detached = paritalo, row_house = rivitalo, apartment_building = kerrostalo, commercial_property = liikekiinteistö.',
    constructionYear: 'Build year as the customer reported it; often NULL.',
    pets: 'Free text for technicians (dog in the bedroom etc).',
    ventilation:
      'JSON document about the ventilation system: { units: [{brand, model, location}], hasPlans: yes|no|unknown, accessNotes, notes }. Built from pre-visit answers and corrected by technicians; the durable facts, whereas visit_pre_infos holds per-visit answers.',
    notes: 'Customer-visible notes about the property.',
    internalNotes:
      'Staff-only operational notes (gate codes, billing quirks). Hidden from the homeowner.',
    data: 'Legacy free-form JSON from earlier booking flows; no fixed shape, rarely useful.',
    addressId: 'Street address and geocoded coordinates; join addresses.',
  },
})
